'use strict';

import {module} from '../app';

module.service('OutsideStudy', [
  '$http', '$q', 'authService', 'magViewApi', function ($http, $q, authService, magViewApi) {
    return {
      getForPatient: function (ssn) {
        const url = `${authService.currentMagViewUrl()}/${magViewApi}/outsideStudy/getOutsideStudies`;
        const model = { ssn };
        return $http.post(url, model);
      },
      post: function (study) {
        const url = `${authService.currentMagViewUrl()}/${magViewApi}/outsideStudy`;
        return $http.post(url, study);
      },

      deleteStudy: function (studyId) {
        const url = `${authService.currentMagViewUrl()}/${magViewApi}/outsideStudy?id=${studyId}`;
        return $http.delete(url);
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/domains/outsideStudy.js